<template>
    <div>
        <h3 class="is-size-4 pt-5 has-text-weight-bold">
            CUENTA BANCARIA EMPRESA
        </h3>
        <p class="mb-5">
            Ingresa el saldo actual y deberás actualizarlo manualmente
        </p>
        <p class="mb-3">
            Si conectaste tus cuentas y tienes inversiones en depósitos a plazo
            o fondos mutuos, puedes usar estas cuentas manuales para reflejar
            esos saldos de tus inversiones.
        </p>
        <div
            v-if="!isSuccessful"
            class="is-flex is-justify-content-space-between is-align-items-end"
        >
            <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
            <b-field class="mb-0" label="Nombre del Banco" label-for="bankName">
                <b-select
                    id="bankName"
                    expanded
                    v-model="selectedFinancialEntity"
                    placeholder="Selecciona un Banco"
                    rules="required"
                >
                    <option
                        v-for="entities in financialEntityList"
                        :key="entities.id"
                        :value="entities.id"
                    >
                        {{ entities.name }}
                    </option>
                </b-select>
            </b-field>
            <b-field
                class="ml-5 mb-0 is-flex-grow-1"
                label="Monto de Cuenta"
                label-for="manualAmount"
            >
                <Input
                    inputId="manualAmount"
                    v-model.lazy="amount"
                    placeholder="$ 1.000.000"
                    v-money="moneyConfig"
                    ref="amount"
                    rules="required|positive-money"
                />
            </b-field>
            <b-button
                type="is-flow"
                class="ml-4 is-align-self-flex-end"
                @click="onAddManualAmount"
                >Agregar</b-button
            >
        </div>
        <b-message
            type="is-danger"
            class="is-size-6 mt-5 filterMessageCustomMessage"
            size="is-small"
            has-icon
            v-show="showError"
            icon="info-circle"
        >
            Ingrese un banco y un monto válido.
        </b-message>
        <b-message
            type="is-success"
            class="is-size-6 mt-5 filterMessageCustomMessage"
            size="is-small"
            has-icon
            v-show="isSuccessful"
            icon="info-circle"
            id="successMsgManual"
        >
            Tu cuenta bancaria fue agregada con éxito
        </b-message>
    </div>
</template>

<script>
import Input from "@/components/inputs/Input";
import { configMoney } from "@/utils/currency";
import { Money } from "@/directives/money";

export default {
    name: "ManualUpload",
    components: {
        Input,
    },
    data() {
        return {
            moneyConfig: configMoney,
            amount: undefined,
            selectedFinancialEntity: undefined,
            showError: false,
        };
    },
    props: {
        financialEntityList: {
            type: Array,
            default: function() {
                return [];
            },
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isSuccessful: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onAddManualAmount: function() {
            if (this.inputsAreValid) {
                this.$emit("onAddManualAmount", {
                    amount: this.formatedAmount,
                    financial_entity: this.selectedFinancialEntity,
                });
            } else {
                this.showError = true;
            }
        },
    },
    computed: {
        formatedAmount: function() {
            return this.amount.replace("$ ", "").replace(/\./g, "");
        },
        inputsAreValid: function() {
            return !!this.selectedFinancialEntity && this.formatedAmount > 0;
        },
    },
    watch: {
        amount: function() {
            if (this.inputsAreValid) this.showError = false;
        },
        selectedFinancialEntity: function() {
            if (this.inputsAreValid) this.showError = false;
        },
        isLoading: function() {
            if (this.isLoading) this.showSuccess = false;
        },
        isSuccessful: function() {
            if (this.isSuccessful) this.amount = "";
            this.selectedFinancialEntity = undefined;
        },
    },
    directives: { money: Money },
};
</script>
